<template>
  <div>
    <NewYear v-if="enigme === 'le-comte-de-minuit'" />
    <Gipsy v-if="enigme === 'lestrade'" />
    <Escape v-if="enigme === 'escape'" />
  </div>
</template>

<script>
import NewYear from "./components/NewYear.vue";
import Gipsy from "./components/Gipsy.vue";
import Escape from "./components/Escape.vue";

export default {
  name: "App",
  components: {
    NewYear,
    Gipsy,
    Escape,
  },
  data() {
    return {
      enigme: window.location.search.substring(1)
    };
  },
  created() {
    if (this.enigme !== "le-comte-de-minuit" && this.enigme !== "lestrade"  && this.enigme !== "escape" ) {
      window.location.replace("https://mystery-and-lock.fr/");
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
html {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
::-webkit-scrollbar {
  display: none;
}
</style>
